import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ConvertJobFragmentDoc } from '../../fragment/generated/convertJob';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetConversionJobQueryVariables = Types.Exact<{
  input: Types.JobFilters;
}>;


export type GetConversionJobQuery = { job?: { jobScheduleId: string, status: Types.JobEntityStatusEnum, error?: string | null, mediaUrls: Array<{ url: string, format: string }>, meta?: { lessonMeta?: { refBlockId: string, pageBlockId: string, htmlUrl: string } | null } | null } | null };


export const GetConversionJobDocument = /*#__PURE__*/ gql`
    query getConversionJob($input: JobFilters!) {
  job(filters: $input) {
    ...ConvertJob
  }
}
    ${ConvertJobFragmentDoc}`;

export function useGetConversionJobQuery(options: Omit<Urql.UseQueryArgs<GetConversionJobQueryVariables>, 'query'>) {
  return Urql.useQuery<GetConversionJobQuery, GetConversionJobQueryVariables>({ query: GetConversionJobDocument, ...options });
};